<template>
  <div class='delete-card-overlay'>
    <p>This card will be deleted.</p>
  </div>
</template>

<script>
  export default {
    data() {
      return {
      }
    },
    props: {
    }
  }
</script>

<style lang='scss' scoped>

  .delete-card-overlay {
    background-color: white;
    padding: 20px;
    border: 1px solid #ccc;
    border-radius: 4px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
  }
</style>



// WEBPACK FOOTER //
// src/components/_modules/Programs/Card-list/DeleteCard.vue